import styled from 'styled-components';
import Icon from '../../assets/images/WarningTriangleIcon.svg';

const ErrorIcon = styled.span`
  background: url(${Icon}) no-repeat left center;
  background-size: 24px 24px;
  display: block;
  position: relative;
  width: 24px;
  height: 24px;
`;

export default ErrorIcon;
